export enum MeterpointStatus {
  AKTIV = 'AKTIV',
  INAKTIV = 'INAKTIV',
}
